/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type RequestResetPasswordMutationVariables = {|
  username: string
|};
export type RequestResetPasswordMutationResponse = {|
  +requestPasswordReset: ?boolean
|};
export type RequestResetPasswordMutation = {|
  variables: RequestResetPasswordMutationVariables,
  response: RequestResetPasswordMutationResponse,
|};
*/


/*
mutation RequestResetPasswordMutation(
  $username: String!
) {
  requestPasswordReset(username: $username)
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "username"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "username",
        "variableName": "username"
      }
    ],
    "kind": "ScalarField",
    "name": "requestPasswordReset",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RequestResetPasswordMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RequestResetPasswordMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "39a68645ee7695346f43e99d5a57dac0",
    "id": null,
    "metadata": {},
    "name": "RequestResetPasswordMutation",
    "operationKind": "mutation",
    "text": "mutation RequestResetPasswordMutation(\n  $username: String!\n) {\n  requestPasswordReset(username: $username)\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '6bbbb36651faac4add669d788a8c50fc';

module.exports = node;
